export default __webpack_public_path__ + "static/media/Liebherr.958107d6.svg";